import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "w-full h-full flex flex-col" }
const _hoisted_2 = { class: "py-3 px-6 flex flex-row items-center gap-x-3 font-montserrat" }
const _hoisted_3 = { class: "font-semibold text-black-lp-100 text-xl" }
const _hoisted_4 = {
  class: "w-full h-full overflow-y-auto py-2 px-4 bg-gray-lp-1200",
  style: {"padding-bottom":"100px"}
}
const _hoisted_5 = {
  class: "bg-white w-full rounded-xl flex flex-col overflow-hidden",
  style: {"min-height":"100%"}
}
const _hoisted_6 = { class: "w-full p-4" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col gap-y-2 px-4 py-6 bg-gray-lp-1900 bg-opacity-75",
  style: {"min-height":"100%"}
}
const _hoisted_8 = { class: "flex flex-col gap-y-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchFlightHeader = _resolveComponent("SearchFlightHeader")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FilterFlight = _resolveComponent("FilterFlight")!
  const _component_StatusHandler = _resolveComponent("StatusHandler")!
  const _component_CardFlight = _resolveComponent("CardFlight")!
  const _component_ModalDelayConfirmation = _resolveComponent("ModalDelayConfirmation")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _imports_0,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
        class: "w-5 mr-3 cursor-pointer",
        alt: _ctx.$t('cargoV2.create.common.backAlt')
      }, null, 8, ["alt"]),
      _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("cargo.v2.flight.search.title.selectSchedule")), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_SearchFlightHeader, {
            customClass: "px-2 mb-5",
            destination: _ctx.searchFlightParams.destinationCityCode,
            destinationName: _ctx.searchFlightParams.destinationCityName,
            origin: _ctx.searchFlightParams.originCityCode,
            originName: _ctx.searchFlightParams.originCityName,
            totalKoli: _ctx.searchFlightParams.actualTotalPiece,
            grossWeight: _ctx.searchFlightParams.actualTotalCargoGrossweight,
            volumeWeight: _ctx.searchFlightParams.actualTotalCargoVolumeweight,
            hasDangerousGoods: _ctx.searchFlightParams.isDangerousGoods,
            hasQuarantine: _ctx.searchFlightParams.isQuarantine
          }, null, 8, ["destination", "destinationName", "origin", "originName", "totalKoli", "grossWeight", "volumeWeight", "hasDangerousGoods", "hasQuarantine"]),
          _createVNode(_component_DatePicker, {
            "start-date": _ctx.searchFlightParams.departureDate,
            "onUpdate:start-date": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchFlightParams.departureDate = $event)),
            "end-date": _ctx.searchFlightResult.departureDateEnd,
            "onUpdate:end-date": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchFlightResult.departureDateEnd = $event)),
            "show-calendar": _ctx.showCalendar,
            "max-selectable-days": _ctx.maxSelectableDays,
            onChange: _ctx.onStartDateChange
          }, null, 8, ["start-date", "end-date", "show-calendar", "max-selectable-days", "onChange"]),
          _createVNode(_component_FilterFlight, {
            disabledFlight: _ctx.isLoading || !_ctx.searchFlightResult.data.length,
            "origin-airport-options": _ctx.originAirportOptions,
            "destination-airport-options": _ctx.destinationAirportOptions,
            "selected-legs": _ctx.filterLegs,
            "onUpdate:selected-legs": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterLegs = $event)),
            "selected-origin-airports": _ctx.filterOriginAirport,
            "onUpdate:selected-origin-airports": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterOriginAirport = $event)),
            "selected-destination-airports": _ctx.filterDestinationAirport,
            "onUpdate:selected-destination-airports": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterDestinationAirport = $event)),
            "selected-sort": _ctx.searchFlightParams.sort,
            "onUpdate:selected-sort": _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchFlightParams.sort = $event)),
            "selected-threshold-time": _ctx.searchFlightParams.thresholdTime,
            "onUpdate:selected-threshold-time": _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchFlightParams.thresholdTime = $event)),
            "onUpdate:selectedSort": _cache[9] || (_cache[9] = (e) => {
              _ctx.searchFlightParams.sort = e;
              _ctx.onFilterFlightChange()
            }),
            "onUpdate:selectedThresholdTime": _cache[10] || (_cache[10] = (e) => {
              _ctx.searchFlightParams.thresholdTime = e;
              _ctx.onFilterFlightChange();
              _ctx.resetFilterAirports();
            })
          }, null, 8, ["disabledFlight", "origin-airport-options", "destination-airport-options", "selected-legs", "selected-origin-airports", "selected-destination-airports", "selected-sort", "selected-threshold-time"])
        ]),
        (_ctx.isLoading || _ctx.error || _ctx.isEmpty)
          ? (_openBlock(), _createBlock(_component_StatusHandler, {
              key: 0,
              icon: _ctx.iconStatus,
              customHeaderMessage: _ctx.headerMessage,
              customMessage: _ctx.bodyMessage,
              buttonAction: !!_ctx.error,
              isLoading: _ctx.isLoading,
              buttonTitle: _ctx.$t('cargo.v2.flight.search.action.reload'),
              buttonIconLeft: "refresh-white",
              buttonTextColor: "white",
              customIconClass: `${_ctx.isEmpty && 'h-36 w-36'} mt-6`,
              customClass: "m-auto",
              onAction: _ctx.fetchSearchFlight
            }, null, 8, ["icon", "customHeaderMessage", "customMessage", "buttonAction", "isLoading", "buttonTitle", "customIconClass", "onAction"]))
          : (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredSearchFlightResult, (flight) => {
                  return (_openBlock(), _createBlock(_component_CardFlight, {
                    key: flight.uniqueId,
                    flight: flight,
                    isSelected: _ctx.selectedFlight.uniqueId === flight.uniqueId,
                    onSelect: _ctx.handleSelectFlight
                  }, null, 8, ["flight", "isSelected", "onSelect"]))
                }), 128))
              ])
            ]))
      ])
    ]),
    (_ctx.isDelayModalOpen)
      ? (_openBlock(), _createBlock(_component_ModalDelayConfirmation, {
          key: 0,
          flight: _ctx.selectedFlight,
          onSave: _ctx.onSave,
          onClose: _ctx.toggleDelayModal
        }, null, 8, ["flight", "onSave", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}